"use client";

import Steps from "@/components/portfolio/Steps";
import MarqueeComponent from "@/components/common/Marquee";
import Footer from "@/components/footers/Footer";
import Header from "@/components/headers/Header";
import Breadcumb2 from "@/components/portfolio/Breadcumb2";
import ProjectDetails from "@/components/portfolio/ProjectDetails";
import { allPortfolio } from "@/data/portfolio";
import Tech from "@/components/portfolio/Tech";
import { useTranslation } from "@/app/i18n/i18n-client";

export default function ProjectPageDetails({ params }) {
  const { slug, locale } = params;
  const { t } = useTranslation(locale, "projects");
  const portfolio = allPortfolio.find((proj) => proj.slug === slug);

 
  return (
    <>
      <Header locale={locale} />
      <Breadcumb2 slug={slug} locale={locale} />
      <ProjectDetails portfolioSlug={slug} />
      <Steps locale={locale} slug={slug} />
      <Tech locale={locale} slug={slug} />
      <MarqueeComponent locale={locale} />
      <Footer locale={locale} />
    </>
  );
}
